<template>
    <div>
        <gooutMonadInfo :mainonebread="mainonebread" :is_all="0"></gooutMonadInfo>
    </div>
</template>

<script>
import gooutMonadInfo from '../gooutmonad/vgooutmonadinfo.vue'
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'vgooutreportmonadinfo',
    data() {
        return {
            mainonebread: [
                {
                    name: '仓库'
                },
                {
                    name: '出入库管理'
                },
                {
                    name: '我的出库报单'
                },
                {
                    name: '详情'
                }
            ]
        }
    },
    components: {
        gooutMonadInfo
    }
})
</script>

<style scoped></style>
